export default __webpack_public_path__ + "static/media/group.9a473697.svg";